import {View, TouchableOpacity} from 'react-native';
import React from 'react';
import I18n, {_m} from 'INTL';
import SkillzSVG from 'SkillzSVG';
import {SkillzText} from '@skillz/ui';
import ModalNavigationController from 'ModalNavigationController';
import WithdrawalInfoModal from '../Modals/WithdrawalInfoModal';
import {
  BONUS_CASH_INFO_TEXT,
  BONUS_CASH_INFO_TITLE,
  UNSETTLED_BALANCE_INFO_TITLE,
} from '../BankWithdrawalConstants';
import {styles} from './AccountDetails.styles';
import WithdrawalPlaythroughInfo from 'WithdrawalPlaythroughInfo';
import ClientPropertyConstants from 'ClientPropertyConstants';
type AccountDetailsProps = {
  accountDetails: {
    cash_balance: number;
    bonus_balance: number;
    real_cash_balance: number;
    withdrawable_balance: number;
  };
};

const AccountDetails = ({accountDetails}: AccountDetailsProps) => {
  const showWithdrawalInfoModal = (text: string) => {
    const withdrawalInfoModal = (
      <WithdrawalInfoModal
        title={text === BONUS_CASH_INFO_TEXT ? BONUS_CASH_INFO_TITLE : UNSETTLED_BALANCE_INFO_TITLE}
        bodyText={text}
        onDismiss={() => {
          ModalNavigationController.hideModal();
        }}
      />
    );
    ModalNavigationController.showModal(withdrawalInfoModal);
  };

  const canWithdraw = accountDetails.withdrawable_balance > 0;

  const withdrawableBalance = ClientPropertyConstants.getPlaythroughEnabled()
    ? accountDetails.withdrawable_balance
    : accountDetails.real_cash_balance;

  return (
    <View style={styles.accountDetailsContainer}>
      <SkillzText style={styles.accountDetailsTitle}>{_m('Withdrawal Details:')}</SkillzText>
      <View style={styles.accountDetailsLine}>
        <View style={styles.lineWithIcon}>
          <TouchableOpacity
            style={styles.infoButton}
            onPress={() => showWithdrawalInfoModal(BONUS_CASH_INFO_TEXT)}
            accessible={true}
            accessibilityLabel={'bonus_cash_info'}
            hitSlop={{top: 10, left: 10, bottom: 10, right: 10}}
          >
            <SkillzSVG source={'italic_info_gray.svg'} style={styles.infoIcon} />
          </TouchableOpacity>
          <SkillzText style={styles.accountDetailsLineKey}>{_m('Bonus Cash')}</SkillzText>
        </View>
        <SkillzText style={styles.amountStyleGray}>
          {I18n.getCurrencyString(accountDetails.bonus_balance, '$', false, false)}
        </SkillzText>
      </View>
      <View style={[styles.accountDetailsLine, styles.noMarginBottom]}>
        <SkillzText style={styles.accountDetailsLineKey}>
          {_m('Available for Withdrawal')}
        </SkillzText>
        <SkillzText style={styles.amountStyle}>
          {I18n.getCurrencyString(withdrawableBalance, '$', false, false)}
        </SkillzText>
      </View>
      <View style={styles.playthroughInfoContainer}>
        <WithdrawalPlaythroughInfo canWithdraw={canWithdraw} playthroughMessageType={'bank'} />
      </View>
    </View>
  );
};

export default AccountDetails;
